import * as $ from "jquery";

export default {
  methods: {
    getOptionValue(optionItemKey) {
      // console.log(optionItemKey);
      if (
        this.options === undefined ||
        this.resolve(optionItemKey, this.options) === undefined ||
        this.resolve(optionItemKey, this.options) === null
      ) {
        return this.resolve(optionItemKey, this.optionDefaults);
      } else {
        return this.resolve(optionItemKey, this.options);
      }
    },
    resolve(path, obj = self, separator = ".") {
      return path.split(separator).reduce((o, i) => o[i], obj);
    },
    calculatePrependWidth() {
      /*setTimeout(() => {
                let maxWidth = 0;
                let array = [];
                for(let i = 1; i <= 10; i++) {
                    array[i] = $(".row > div:nth-child("+ i +") .input-group-text").width();
                }
                for (let item of array) {
                    console.log(item);
                    if (item > maxWidth)
                        maxWidth = item;
                }
                maxWidth += 24;
                $(".input-group-prepend.custom").css("width", maxWidth + "px");
            }, 500);*/
    },
    hasAccess(accessIdentifier) {
      let access = this.$route.meta.access;
      if (access && access.accesses) {
        return access.accesses.includes(accessIdentifier);
      }
    }
  }
};
